import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-181883e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = { class: "lg:justify-between lg:items-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-left text-primary mb-2" }, " Pagos en proceso de aplicación ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomTable = _resolveComponent("CustomTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_CustomTable, {
            description: "Listado de Pagos",
            columns: $setup.columns,
            rows: $setup.rows,
            limit: 10,
            noContent: "No tiene pagos en proceso de aplicación",
            loading: $setup.loading
          }, {
            bank: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(row.bank), 1)
            ]),
            payment_date: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(_ctx.$filters.formatDate(row.payment_date)), 1)
            ]),
            payment_value: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(_ctx.$filters.currency(row.payment_value)), 1)
            ]),
            canal: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(row.canal), 1)
            ]),
            _: 1
          }, 8, ["columns", "rows", "loading"])
        ])
      ])
    ])
  ]))
}